<footer class="">
  <div class="footer-content">
    <div class="logo-container">
      <span class="cursor-pointer" (click)="goToCigna()">
        <svg class="app-footer--logoIzquierda--logo" alt="logo cigna">
          <use href="./assets/images/svg/images-sprite.svg#logo-white" />
        </svg>
      </span>
    </div>
    <div class="footer-info-links-container">
      <p-button
        class="footer-info-link underline-link"
        (onClick)="modalFooter('legal')"
        [label]="'footer.legal' | translate"
        [tabindex]="5"></p-button>

      <p-button
        class="footer-info-link underline-link"
        (onClick)="modalFooter('cookies')"
        [label]="'footer.cookies' | translate"
        [tabindex]="5"></p-button>

      <p-button
        class="footer-info-link underline-link"
        (onClick)="modalFooter('privacidad')"
        [label]="'footer.privacidad' | translate"
        [tabindex]="5"></p-button>
      <div class="footer-info-link" tabindex="-1">
        {{ 'footer.copy' | translate: { year: year } }}
      </div>
    </div>
  </div>
  <div class="absolute app-footer--leaves-derecha">
    <svg class="display-none-phone" alt="leaves cigna">
      <use href="./assets/images/svg/images-sprite.svg#leaves-pattern" />
    </svg>
  </div>
</footer>
